import * as AppPics from 'assets/images';

function Html() {
  return (
    <div className="mainWraper addcoursesection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">Notes</li>
          <li>Videos</li>
          <li>Stories</li>
          <li>Sprint</li>
          <li>Mind Tree</li>
          <li>Geek Corner</li>
          <li>Echoes</li>
        </ul>
        <div className="tab__content p-4">
          <div className="container p-0">
            <div className="row">
              <div className="col-12 publishheader">
                <h2 className="prime-head p-0 boldtitle">Test Sub Lesson 1</h2>
                <div className="row  mb-4 btnsubmitmain">
                  <div className="btnTab-foot">
                    <button className="btn-right-content next">Publish Content</button>
                  </div>
                </div>
                <div className="custom-control custom-checkbox draftcheckbox">
                  <input
                    type="checkbox"
                    name="check"
                    className="custom-control-input"
                    id="customCheck2"
                  />
                  <label className="custom-control-label" htmlFor="customCheck2">
                    Draft
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 Texteditorsection">
                <div className="row">
                  <div className="col-4 m-auto align-center">
                    <div className="storyouter blocksection mt-3">
                      <img className="sliderSec-boxImg" src={AppPics.BlockSvg} alt="" />
                    </div>
                    <div className="blockcontrol mt-3">
                      <a className="editcontrol">
                        <div className="storytitlename">
                          <span className="mx-2">
                            <img src={AppPics.EditSvg} alt="" />
                          </span>
                          Edit Block
                        </div>
                      </a>
                      <a className="deletecontrol">
                        <div className="storytitlename">
                          <span className="mx-2">
                            <img src={AppPics.DeleteSvg} alt="" />
                          </span>
                          Delete Block
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="row contentaddbtnouter">
                  <div className="col-12">
                    <div className="addcontent">
                      <a className="addsymbol">+</a>
                      <div className="contentbuttonsection">
                        <a className="buttonfield">
                          <span className="icon">
                            <img src={AppPics.TextSvg} alt="" />
                          </span>
                          <span className="label">Text</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon image">
                            <img src={AppPics.ImageSvg} alt="" />
                          </span>
                          <span className="label">Image</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon">
                            <img src={AppPics.EquationSvg} alt="" />
                          </span>
                          <span className="label">Equation</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon">
                            <img src={AppPics.ProblemSvg} alt="" />
                          </span>
                          <span className="label">Problem</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon">
                            <img src={AppPics.TipSvg} alt="" />
                          </span>
                          <span className="label">Tip</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon">
                            <img src={AppPics.BoxSvg} alt="" />
                          </span>
                          <span className="label">Box</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon video">
                            <img src={AppPics.VideoSvg} alt="" />
                          </span>
                          <span className="label">Video</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon audio">
                            <img src={AppPics.AudioSvg} alt="" />
                          </span>
                          <span className="label">Audio</span>
                        </a>
                        <a className="buttonfield">
                          <span className="icon file">
                            <img src={AppPics.FileSvg} alt="" />
                          </span>
                          <span className="label">File</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-5 btnsubmitmain">
              <div className="col-12 btnTab-foot">
                <button className="btn-right-content save">Save Changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html;
